<template>
  <v-content class="mypage">
    <div v-if="isPreview">
      <v-container class="userinfo lighten-5">
        <v-row justify="center">
          <v-col style="color:#8a8a8a; font-weight:bold">
            ユーザーアイコン
          </v-col>
          <v-col style="text-align:right">
            <i class="fas fa-user-circle" style="font-size: 35px; color: #8a8a8a;"></i>
          </v-col>
        </v-row>
        <v-row  no-gutters>
          <v-col style="color:#8a8a8a;">
            会員ID
          </v-col>
          <v-col style="text-align:right" class="pr-2">
            <span v-if="init.user_id">{{init.user_id}}</span>
            <span v-else>XXXXX</span>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="lighten-5 mb-6 formwrap">
        <div class="pl-4 pr-4" v-if="profile.name_display_flg">
          <span style="font-size: 13px; font-weight: 900; color: #8a8a8a;">お名前</span>
          <v-text-field label="入力してください"></v-text-field>
        </div>
        <div class="pl-4 pr-4" v-if="profile.name_kana_display_flg">
          <span style="font-size: 13px; font-weight: 900; color: #8a8a8a;">お名前（カナ）</span>
          <v-text-field label="入力してください"></v-text-field>
        </div>
        <div class="pl-4 pr-4" v-if="profile.birthday_display_flg">
          <span style="font-size: 13px; font-weight: 900; color: #8a8a8a;">お誕生日</span>
          <span class="requiredText" v-if="profile.birthday_required_flg">必須</span>
          <v-text-field :value="date"></v-text-field>
        </div>
        <div class="pl-4 pr-4" v-if="profile.gender_display_flg" style="margin-bottom: 7px;">
          <span style="font-size: 13px; font-weight: 900; color: #8a8a8a;">性別</span>
          <span class="requiredText" v-if="profile.gender_required_flg">必須</span>
          <v-row class="btnwrap" style="margin: auto;">
            <v-btn rounded color="normal" outlined>男性</v-btn>
            <v-btn rounded color="normal" outlined>女性</v-btn>
            <v-btn rounded color="normal" outlined style="color:#fff;" class="maincolor-bg">指定なし</v-btn>
          </v-row>
        </div>

        <!-- 追加項目 -->
        <div class="pl-4 pr-4" v-for="(item, index) in profile.items" :key="index">
          <span style="font-size: 13px; font-weight: 900; color: #8a8a8a;">{{item.koumoku_mei}}</span>
          <span class="requiredText" v-if="item.required_flg">必須</span>
          <div v-if="item.koumoku_type_id == 1"><!-- フリーワード -->
            <v-text-field label="入力してください"></v-text-field>
          </div>
          <div v-else-if="item.koumoku_type_id == 2"><!-- 択一選択 -->
            <v-text-field label="選択してください"></v-text-field>
          </div>
          <div v-else-if="item.koumoku_type_id == 3"><!-- 複数選択 -->
            <v-text-field label="選択してください"></v-text-field>
          </div>
          <div v-else-if="item.koumoku_type_id == 4"><!-- 数字 -->
            <v-text-field label="00" v-if="item.affix.length == 0"></v-text-field>
            <v-row class="btnwrap" v-else style="margin: 0 auto 7px; padding: 0;">
              <v-col v-if="item.affix.prefix">{{item.affix.prefix}}</v-col>
              <v-col style="color: #a2a2a2;">00</v-col>
              <v-col v-if="item.affix.sufix">{{item.affix.sufix}}</v-col>
            </v-row>
          </div>
          <div v-else-if="item.koumoku_type_id == 5"><!-- 日付 -->
            <!--v-text-field label="0000年00月00日"></v-text-field-->
            <div class="btnwrap d-flex justify-start" style="margin: 5px auto 7px; padding: 10px 10px 0;">
              <p v-if="item.date_format.year" style="color: #a2a2a2;">0000年</p>
              <p v-if="item.date_format.month" style="color: #a2a2a2;">00月</p>
              <p v-if="item.date_format.day" style="color: #a2a2a2;">00日</p>
            </div>
          </div>
        </div>

        <v-row justify="center" class="mt-8">
          <v-btn rounded color="normal" outlined class="maincolor-bg profileRegistBtn">登録する</v-btn>
        </v-row>
        <p class="mt-4 text-center" style="font-size: 12px">本アプリをご利用の際には、<span style="text-decoration: underline;">利用規約</span>をご確認ください。</p>

        <p class="text-center" v-if="init.copyright" style="font-size: 12px; margin-top:60px;">© {{init.copyright}} All right reserved.</p>

      </v-container>
    </div>
  </v-content>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      init: [],
      isPreview: false,
      profile: null,
      date: null
    };
  },
  async created() {
    if (this.$route.query && this.$route.query.preview) {
      this.isPreview = true;
      this.init = this.storageGet('*');

      let res = await this.apiCall('/user/profile', {params:{preview: 1}});
      if (res && res.items) {
        this.profile = res;
      }

      let today = new Date();
      this.date = today.getFullYear() + '年' + (today.getMonth() + 1) + '月' + today.getDate() + '日';
    }
  },
  methods: {
  },
};
</script>

<style scoped>
  .profileRegistBtn {
    width: 60%;
  }
</style>

<style>
.userinfo {
  background-color: #ccc !important;
}
.formwrap .v-label {
  color: #8a8a8a;
}
.formwrap .v-text-field__details {
  display: none;
}
.formwrap .v-text-field {
  margin-top: 0;
}
.formwrap .v-text-field input {
  padding: 20px 10px 15px 10px;
}
.formwrap .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #ccc;
}
.formwrap .btnwrap {
  border-bottom: 1px solid #ccc;
  width: 100%;
  padding: 20px 10px 15px 10px;
}
.btnwrap .v-btn {
  width: 31%;
  margin-right: 2%;
}
.requiredText {
  font-size: 11px;
  color: #fff;
  background-color: red;
  padding: 0px 7px;
  border-radius: 20px;
  margin-left: 10px;
  position: relative;
  top: -1px;
}
</style>
